import { makeAutoObservable } from "mobx";
import { IdentifiableMap, RSet } from "../../collections";
import { SingleProductInstancePart, } from "../ProductInstance";
export class SinglePartCreatorState {
    constructor(params) {
        this.isSplit = false;
        this.productCategory = params.productCategory;
        this.commonModifierInstanceCreators = params.commonModifierInstanceCreators;
        this.commonCustomParameterInstanceCreators =
            params.commonCustomParameterInstanceCreators;
        this.partCreator = params.partCreator;
        this.creatorScopeProvider = params.creatorScopeProvider;
        makeAutoObservable(this);
    }
    get productTypeIds() {
        return RSet.singleton(this.partCreator.productTypeId);
    }
    get commonModifierInstances() {
        return new IdentifiableMap(this.commonModifierInstanceCreators.raw.map((c) => c.modifierInstance));
    }
    get commonCustomParameterInstances() {
        return new IdentifiableMap(this.commonCustomParameterInstanceCreators.raw.map((c) => c.customParameterInstance));
    }
    get productInstanceParts() {
        return new SingleProductInstancePart(this.partCreator.productInstancePart);
    }
    selectInferredDefaults() {
        this.commonModifierInstanceCreators.objects.forEach((m) => m.selectInferredDefaults());
        this.partCreator.selectInferredDefaults();
    }
}
